<div
  class="container-fluid d-flex justify-content-center align-items-center my-container"
>
  <div class="text-center d-block p-2">
    <img [src]="'assets/flyplus/app-logo.svg' | assets" class="mb-3" />
    <app-loader [isLoading]="true" [message]="'Redirecting...'"></app-loader>
  </div>
</div>
